import { AutogenModelFuelFundedVendor, AutogenRowFuelFundedVendor } from "./autogen/AutogenModelFuelFundedVendor";

export class ModelFuelFundedVendor extends AutogenModelFuelFundedVendor<RowFuelFundedVendor> {
	constructor() {
		super(RowFuelFundedVendor);
	}
}

export class RowFuelFundedVendor extends AutogenRowFuelFundedVendor {
}